import { db } from './db.js'

const FINANCE_SETTINGS_KEY = 'finance_settings'

export async function getFinanceSettings() {
  const row = await db.settings.get(FINANCE_SETTINGS_KEY)
  return row?.value || { enabled: true, hideValues: false }
}

export async function saveFinanceSettings(settings) {
  await db.settings.put({ key: FINANCE_SETTINGS_KEY, value: settings })
}
